import { css } from 'aphrodite';
import * as React from 'react';
import { IIntegrationConfigurationRequirement } from '../../../queries/Admin/IntegrationsHealth';
import { Button } from '../../../web/components-v2/Button';
import { Pill } from '../../../web/components-v2/Pill';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../web/components/Tooltip';
import { SettingsIcon } from '../../../web/components/svgs/icons/SettingsIcon';
import { styleSheet } from './styles';

interface IProps {
	requirements: IIntegrationConfigurationRequirement[];
	heading?: string;
	footnote?: string;
}

export const SetupRequirements: React.FC<IProps> = ({ requirements, heading = 'Setup required', footnote }) => {
	if (!requirements.length) {
		return null;
	}

	const label = requirements.length === 1 ? requirements[0].message : `${requirements.length} items outstanding`;

	return (
		<span className={css(styleSheet.setupCell)}>
			<Tooltip>
				<TooltipTrigger asChild>
					<Button
						variant='ghost'
						size='icon'
						styles={[styleSheet.setupTrigger]}
						aria-label={`${heading}: ${requirements.length} ${requirements.length === 1 ? 'item' : 'items'}`}
					>
						<SettingsIcon className={css(styleSheet.setupIcon)} stroke={THEME.colors.warning.dark} />
						<span className={css(styleSheet.setupIndicator)} />
					</Button>
				</TooltipTrigger>
				<TooltipContent styles={[styleSheet.setupTooltip]}>
					<span className={css(styleSheet.setupTooltipHeading)}>{heading}</span>
					<ul className={css(styleSheet.setupTooltipList)}>
						{requirements.map((requirement, i) => (
							<li key={`${requirement.field}-${requirement.state}-${i}`}>
								{requirement.message}
								<RequirementActor actor={requirement.actor} />
							</li>
						))}
					</ul>
					{footnote ? <span className={css(styleSheet.setupTooltipFootnote)}>{footnote}</span> : null}
				</TooltipContent>
			</Tooltip>
			<span className={css(styleSheet.setupLabel)}>{label}</span>
		</span>
	);
};

const RequirementActor: React.FC<{ actor: IIntegrationConfigurationRequirement['actor'] }> = ({ actor }) => {
	if (!actor) {
		return null;
	}
	const isCustomer = actor === 'Customer';
	return (
		<Pill
			variant='tag'
			size='small'
			color={isCustomer ? 'orange' : 'gray'}
			label={isCustomer ? 'Customer action' : 'You can fix'}
		/>
	);
};
